import {HTTP} from "../http";

export default {
    namespaced: true,

    state: {
        loading: false,
        users: []
    },

    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },

        setUsers(state, users) {
            state.users = users;
        }
    },

    actions: {
        load({ commit }) {
            commit('setLoading', true);

            return HTTP.get('/admin/users')
                .then(resp => commit('setUsers', resp.data))
                .then(() => commit('setLoading', false))
                .catch(err => context.commit('error/set', err.response.data, { root: true }));
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/admin-users.js